"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAccessClick = void 0;
var analytics_layer_1 = require("@pmi/analytics-layer");
var getAccessClick = function () {
    var eventData = {
        event: analytics_layer_1.ButtonInteractionEventNames.GetAccessClick,
        eventInfo: analytics_layer_1.ButtonInteractionEventNames.GetAccessClick,
    };
    return eventData;
};
exports.getAccessClick = getAccessClick;
